import { useCallback } from 'react'

import { ERROR_RESET_PASSWORD_FAILURE, RESET_PASSWORD_SUCCESS } from '@/app/module/auth/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export type ResetPasswordValues = {
  key: string | null
  password1: string
  password2: string
}

export const useResetPassword = () => {
  const dispatch = useAppDispatch()
  const [resetPassword, res] = esApi.endpoints.authPasswordResetChange.useMutation()

  const reset = useCallback(
    async (values: ResetPasswordValues) => {
      try {
        await resetPassword({
          body: {
            key: values.key || '',
            password1: values.password1,
            password2: values.password2,
          },
        }).unwrap()
        dispatch(
          createNotification({
            'reset-password-success': { type: 'success', message: RESET_PASSWORD_SUCCESS },
          }),
        )
        return true
      } catch (error) {
        const errorMessage = getErrorMessage(error, ERROR_RESET_PASSWORD_FAILURE)
        dispatch(
          createNotification({
            'reset-password-error': { type: 'error', message: errorMessage },
          }),
        )
        return false
      }
    },
    [dispatch, resetPassword],
  )

  return [reset, res] as const
}
